<template>
  <div class="projetovalidacao">
    <loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
    <div class="container-fluid">
	  <ol class="breadcrumb-arrow">
		  <li>
			<a href="/home"><i class="fa fa-home"></i></a>
			<a href="/projeto-listagem">Projetos</a>
		  </li>
		  <li>
			<a href="#">Validação
			  </a>
		  </li>
		</ol>

    </div>
    <div class="container-fluid mt-2">
		<form class=" mt-2">
			<div class="container-fluid mt-2">
				<div class="card">
					<div class="card-body">
						<div class="row ml-0 mr-0 page-header-title">
							<div class="col-lg-10 col-sm-6 pr-0 pl-0 d-none d-sm-block d-lg-block d-xl-block">
								<h2 class="text-header txt-bloqueio">Projetos em Validação</h2>
							</div>
							<div class="col-lg-2 col-sm-2 nput-search pl-0 nput-group d-flex pr-0">
								<input class="input-pesquisa-imprimir inputiPad search-menu"
									placeholder="Pesquisar..."
									v-model="filtroTipo"
									@keyup="filtrarTipo" />
							</div>
						</div>
						<div id="accordionPendentes">
							<table class="table table-hover">
								<thead style="background-image: linear-gradient(to left, white, #f2f2f2)">
									<tr>
										<th width="100%">Projeto</th>
									
									</tr>
								</thead>
								<tbody>
									<tr v-for="(validacao, index) in listaProjeto" :key="validacao.projeto.idprojeto">
										<td  style="max-width: 200px; max-height: max-content; white-space: nowrap; overflow: hidden;" class="clickable"
												:id="`heading` + index"
												data-toggle="collapse"
												:data-target="`#collapse` + index"
												aria-expanded="true"
												:aria-controls="`collapse` + index">
											<el-tooltip :content="validacao.projeto.nomeCodigo" placement="top">
												<strong >{{ validacao.projeto.nomeCodigo }}</strong>
											</el-tooltip>

											<span class="alinhado-direita">
												<span v-if="responsaRespondida(validacao, validacao.listaValidacao)">
													<el-tooltip  content="Aceitar responsabilidade" placement="top">
														<i class="far fa-thumbs-up pr-2 pl-2 text-success clickable"
															@click="aceitarResponsabilidade(validacao.projeto)"></i>
													</el-tooltip>
													<el-tooltip content="Rejeitar responsabilidade" placement="top">
														<i class="far fa-thumbs-down pr-2 pl-2 text-danger clickable"
															@click="abrirModalRejeiteResponsabilidade(validacao.projeto)"></i>
													</el-tooltip>
												</span>
												<span v-if="coordRespondida(validacao.listaValidacao)">
													<el-tooltip content="Validar projeto" placement="top">
														<i class="fas fa-thumbs-up pr-2 pl-2 text-success clickable"
															@click="validarCoordenacao(validacao.projeto)"></i>
													</el-tooltip>
													<el-tooltip content="Rejeitar projeto" placement="top">
														<i class="fas fa-thumbs-down pr-2 pl-2 text-danger clickable"
															@click="abrirModalRejeiteCoordenacao(validacao.projeto)"></i>
													</el-tooltip>
												</span>
											</span>
											<div :id="`collapse` + index" class="collapse mt-3" :aria-labelledby="`heading` + index" data-parent="#accordionPendentes">								
												<div class="row p-1">
													<div class="col-6">
														<div class="row p-1">
															<div class="col-6">
																<strong>Período:</strong> {{validacao.projeto.dataInicio}} <strong>a</strong> {{validacao.projeto.dataFim}}
															</div>
															<div class="col-2">
																<strong>Criado por:</strong> 
															</div>
															<div class="col-1">
																<img :src="validacao.projeto.criador.avatar" :title="validacao.projeto.criador.nome" width="27" class="rounded-circle ml-2 mr-2 mt-n1">
															</div>
															<div class="col ml-2">
																{{validacao.projeto.criador.apelido}}
															</div>
														</div>
														<div class="row p-1">
															<div class="col-6">
																<strong>Classificação:</strong> {{validacao.projeto.classificacao}}
															</div>
															<div class="col-6">
																<strong>Relevância:</strong> {{validacao.projeto.relevanciaCriador}}
															</div>
														</div>
														<div class="row p-1">
															<div class="col-6">
																<strong>Grupo(s) de Trabalho:</strong> <br/>
																<span class="ml-2" v-for="gt in validacao.projeto.listaGrupoTrabalho" :key="gt.idgt">
																	- {{gt.nome}}<br/>
																</span>
															</div>
															<div class="col-6">
																<strong>Responsável(is):</strong> <br/>
																<div class="row mt-1 mb-2" v-for="r in validacao.projeto.listaResponsavel" :key="r.idusuario">
																	<div class="col-1">
																		<img :src="r.avatar" :title="r.nome" width="27" class="rounded-circle mr-2 mt-n1">
																	</div>
																	<div class="col ml-3">
																		{{r.apelido}}
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="col-6" style="border-left: 1px solid #C0C0C0">
														<strong>Validações:</strong> <br/>
														<div class="row" v-for="v in validacao.listaValidacao" :key="v.idprojetovalidacao">

															<div class="col-11">
																<div class="row" v-if="v.coordenacao == null">
																	<span class="text-wrap">
																		&nbsp;&nbsp;{{ v.usuario.nome }}
																	</span>
																</div>
																<div class="row" v-if="v.coordenacao != null">
																	<span class="text-wrap">
																		&nbsp;&nbsp;{{ v.coordenacao.nome }} - {{ v.coordenacao.sigla }}
																	</span>
																</div>
															</div>
															<div class="col-1">
																<el-tooltip :content="`Aceito `+ v.tempoDataHora" placement="top" v-if="v.respondido && v.validado">
																	<i class="far fa-thumbs-up text-success"></i>
																</el-tooltip>
																<el-tooltip :content="`Negado `+ v.tempoDataHora" placement="top" v-if="v.respondido && !v.validado">
																	<i class="far fa-thumbs-down text-danger"></i>
																</el-tooltip>
																<el-tooltip content="Pendente" placement="top" v-if="!v.respondido">
																	<i class="far fa-clock"></i>
																</el-tooltip>
															</div>
														</div>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

			</div>
		</form>
    </div>

	<modal :show.sync="modals.modalRejeiteResponsabilidade">
		<form class="ml-3 mt-3 mr-3 mb-3">
		<h4 class="text-center">Rejeitar a responsabilidade do Projeto</h4><br/>
		<strong>Projeto:</strong> {{projeto.titulo}}<br />
		<strong>Período:</strong> {{projeto.dataInicio}} a {{projeto.dataFim}}<br />
		<div class="mt-2 input-group">
			<div class="input-group-prepend mb-2">
				<span class="input-group-text"><i class="fas fa-align-left"></i></span>
			</div>
			<textarea rows="2" v-model="justificativa"
				class="form-control mb-2"
				placeholder="Escreva uma justificativa para esse rejeite"></textarea>
		</div>
		<br class="clear" />
		<div class="col-md-12 text-center mt-3">
			<button type="button"
				class="btn btn-danger"
				@click="fecharModal()">
				Desistir
			</button>
			<button type="button"
				class="btn btn-primary ml-4"
				@click="salvarRejeicaoResponsabilidade()">
				Rejeitar
			</button>
		</div>
		</form>
	</modal>

	<modal :show.sync="modals.modalRejeiteCoordenacao">
		<form class="ml-3 mt-3 mr-3 mb-3">
		<h4 class="text-center">Rejeitar Projeto</h4><br/>
		<strong>Projeto:</strong> {{projeto.titulo}}<br />
		<strong>Período:</strong> {{projeto.dataInicio}} a {{projeto.dataFim}}<br />
		<div class="mt-2 input-group">
			<div class="input-group-prepend mb-2">
				<span class="input-group-text"><i class="fas fa-align-left"></i></span>
			</div>
			<textarea rows="2" v-model="justificativa"
				class="form-control mb-2"
				placeholder="Escreva uma justificativa para esse rejeite"></textarea>
		</div>
		<br class="clear" />
		<div class="col-md-12 text-center mt-3">
			<button type="button"
				class="btn btn-danger"
				@click="fecharModal()">
				Desistir
			</button>
			<button type="button"
				class="btn btn-primary ml-4"
				@click="salvarRejeicaoCoordenacao()">
				Rejeitar
			</button>
		</div>
		</form>
	</modal>

  </div>
</template>

<script>
const customLabels = {
	first: "<<",
	last: ">>",
	previous: "<",
	next: ">",
};

const defaultStyles = {
	ul: {
		margin: 0,
		padding: 0,
		display: "inline-block",
	},
	li: {
		listStyle: "none",
		display: "inline",
		textAlign: "center",
	},
	a: {
		cursor: "pointer",
		padding: "7px 7px",
		display: "block",
		float: "left",
	},
};

export default {
  components: {},
  created() {
    this.carregarProjetosPendentes();
	this.verificarPerfilUsuario();
  },
	data() {
		return {
			pageOfItems: [],
			progress: true,
			listaProjeto: [],
			listaProjetoFiltro: [],
			filtroTipo: "",
			customLabels,
			defaultStyles,
			projeto: {},
			justificativa: "",
			perfilCoordenador: false,
			modals: {
				modalRejeiteResponsabilidade: false,
				modalRejeiteCoordenacao: false,
			},
			filtro: {
				idPerfil: "",
			},
		};
	},
	methods: {
		onChangePage(pageOfItems) {
			// update page of items
			this.pageOfItems = pageOfItems;
		},
		verificarPerfilUsuario() {
			this.$clubApi.get("/user/obter").then((response) => {
				console.log("usuarioooo", response.data.object);
				let perfil = response.data.object.profile;
				let perfils = response.data.object.profiles.filter((perfil) => perfil.nome == "COORDENADOR");
				console.log("COORDENADOR???? ", (perfil == "COORDENADOR") || (perfils.length > 0));
				this.perfilCoordenador = (perfil == "COORDENADOR") || (perfils.length > 0);
			});
		},
		filtrarTipo() {
			if (this.filtroTipo === "") {
				this.listaProjeto = this.listaProjetoFiltro;
			} else {
				this.listaProjeto = this.listaProjetoFiltro.filter((item) => {
					return (
						item.projeto.nomeCodigo.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0
					);
				});
			}
		},
		responsaRespondida(validacao, listaValidacao) {
			const novaLista = listaValidacao.filter( (item) => {
				return (item.usuario != null 
					&& item.usuario.idusuario == localStorage.getItem("idusuario")
					&& !item.respondido);
			});
			return novaLista.length > 0;
		},
		coordRespondida(listaValidacao) {
			const novaLista = listaValidacao.filter( (item) => {
				return (item.usuario == null && !item.respondido);
			});
			return novaLista.length > 0 && this.perfilCoordenador;
		},
		validarCoordenacao(projeto) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Como Coordenador, deseja validar esse projeto?', options)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						let validacao = {
							projeto: {
								idprojeto: projeto.idprojeto
							},
							validado: true
						}
						this.$clubApi.post("/projeto/validacao/coordenacao", validacao).then(() => {
							this.carregarProjetosPendentes();
							this.$toastr.success("Validação do projeto realizada com sucesso!");
						})
						.catch((error) => {
							this.$toastr.warning(error.response.data.msg);
							this.progress = false;
						});
					}
				});
		},
		aceitarResponsabilidade(projeto) {
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja aceitar a responsabilidade desse projeto?', options)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						let validacao = {
							projeto: {
								idprojeto: projeto.idprojeto
							},
							validado: true
						}
						this.$clubApi.post("/projeto/validacao/responsabilidade", validacao).then(() => {
							this.carregarProjetosPendentes();
							this.$toastr.success("Aceite da responsabilidade com sucesso!");
						})
						.catch((error) => {
							this.$toastr.warning(error.response.data.msg);
							this.progress = false;
						});
					}
				});
		},
		abrirModalRejeiteCoordenacao(projeto) {
			this.projeto = projeto;
			this.modals.modalRejeiteCoordenacao = true;
			this.modals.modalRejeiteResponsabilidade = false;
		},
		abrirModalRejeiteResponsabilidade(projeto) {
			this.projeto = projeto;
			this.modals.modalRejeiteResponsabilidade = true;
			this.modals.modalRejeiteCoordenacao = false;
		},
		salvarRejeicaoCoordenacao() {
			if (this.justificativa == undefined || this.justificativa == "") {
				this.$toastr.error("Campo Justificativa é obrigatório!");
				return;
			}
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.modals.modalRejeiteCoordenacao = false;
			this.$dialogs.confirm('Deseja realmente rejeitar esse projeto por completo?', options)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						let validacao = {
							projeto: {
								idprojeto: this.projeto.idprojeto
							},
							justificativa: this.justificativa,
							validado: false
						}
						this.$clubApi.post("/projeto/validacao/coordenacao", validacao).then(() => {
							this.$toastr.success("Projeto rejeitado com sucesso!");
							this.carregarProjetosPendentes();
							this.projeto = {};
						})
						.catch((error) => {
							this.$toastr.warning(error.response.data.msg);
							this.progress = false;
						})
						.finally(() => {
							this.justificativa = "";
						});
					} else {
						this.justificativa = "";
					}
				});
		},
		salvarRejeicaoResponsabilidade() {
			if (this.justificativa == undefined || this.justificativa == "") {
				this.$toastr.error("Campo Justificativa é obrigatório!");
				return;
			}
			const options = {
				title: "Confirmação",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.modals.modalRejeiteResponsabilidade = false;
			this.$dialogs.confirm('Deseja realmente negar a responsabilidade desse projeto?', options)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						let validacao = {
							projeto: {
								idprojeto: this.projeto.idprojeto
							},
							justificativa: this.justificativa,
							validado: false
						}
						this.$clubApi.post("/projeto/validacao/responsabilidade", validacao).then(() => {
							this.$toastr.success("Negada a responsabilidade com sucesso!");
							this.carregarProjetosPendentes();
							this.projeto = {};
						})
						.catch((error) => {
							this.$toastr.warning(error.response.data.msg);
							this.progress = false;
						})
						.finally(() => {
							this.justificativa = "";
						});
					} else {
						this.justificativa = "";
					}
				});
		},
		
		fecharModal() {
			this.modals.modalRejeiteCoordenacao = false;
			this.modals.modalRejeiteResponsabilidade = false;
			this.projeto = {};
			this.justificativa = "";
		},
		carregarProjetosPendentes() {
			this.progress = true;
			this.filtro.idPerfil = localStorage.getItem("trocaPerfil")
			this.$clubApi.post("/projeto/validacaoperfil", this.filtro).then((response) => {
				this.listaProjeto = response.data.object;
				this.listaProjetoFiltro = response.data.object;
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
	}
}
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
	cursor: pointer;
}
.clickable:hover {
	cursor: pointer;
	text-decoration: none;
}
.alinhado-direita {
	float: right;
}
</style>
